import { domReady } from '@/utils/dom-ready'

const MIN_SCREEN_WIDTH_SM = 768

function showActions(parentElement) {
  const expandActions = parentElement.querySelector('.expand-actions')
  const collapseActions = parentElement.querySelector('.collapse-actions')
  const actions = parentElement.querySelector('.actions')

  expandActions.classList.add('d-none')
  expandActions.classList.remove('d-flex')

  collapseActions.classList.add('d-flex')
  collapseActions.classList.remove('d-none')

  actions.classList.remove('d-none')
  actions.style.display = 'flex'
}

function hideActions(parentElement) {
  const actions = parentElement.querySelector('.actions')
  const expandActions = parentElement.querySelector('.expand-actions')
  const collapseActions = parentElement.querySelector('.collapse-actions')

  actions.style.display = 'none'

  // Toggle the expand / collapse actions section
  expandActions.classList.remove('d-none')
  expandActions.classList.add('d-flex')

  collapseActions.classList.remove('d-flex')
  collapseActions.classList.add('d-none')
}

domReady(() => {
  if (document.querySelectorAll('.collapsable-actions').length === 0) {
    return
  }

  const expanders = document.querySelectorAll('.collapsable-actions .expand-actions')
  expanders.forEach(expander => {
    expander.addEventListener('click', (evt) => {
      evt.preventDefault()
      const parentElement = evt.target.closest('.collapsable-actions')
      showActions(parentElement)
    })
  })

  const collapsers = document.querySelectorAll('.collapsable-actions .collapse-actions')
  collapsers.forEach(collapser => {
    collapser.addEventListener('click', (evt) => {
      evt.preventDefault()
      const parentElement = evt.target.closest('.collapsable-actions')
      hideActions(parentElement)
    })
  })

  const showActionsForNonXsScreen = function() {
    if (window.innerWidth >= MIN_SCREEN_WIDTH_SM) {
      // We're not on an xs screen, so show the actions and reset the xs-only expand/collapse controls
      const actions = document.querySelectorAll('.collapsable-actions .actions')
      actions.forEach(action => {
        action.style.display = 'block'
        action.classList.add('d-none')
      })

      expanders.forEach(expander => {
        expander.classList.add('d-flex')
      })

      collapsers.forEach(collapser => {
        collapser.classList.add('d-none')
      })
    }
  }

  window.addEventListener('resize', showActionsForNonXsScreen)
  window.addEventListener('unload', () => {
    window.removeEventListener('resize', showActionsForNonXsScreen)
  })
})
